import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseComponent} from '../../base.component';
import * as SharedModels from '@shared-models/index';

@Component({
    selector: 'ui-user-profile-dropdown',
    templateUrl: './user-profile-dropdown.component.html',
    styleUrls: ['./user-profile-dropdown.component.less']
})
export class UserProfileDropdownComponent extends BaseComponent implements OnInit, OnChanges {

    @Input() user: SharedModels.CM.IUserData;
    @Input() userPhotoFile: Blob;

    userInitials: string;
    userPhoto: string | ArrayBuffer;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.fillUser();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.userPhotoFile && changes.userPhotoFile.currentValue) {
            this.createImageFromBlob(this.userPhotoFile);
        }
    }

    private fillUser(): void {
        this.userInitials = this.getInitials();
        this.createImageFromBlob(this.userPhotoFile);
    }

    private getInitials(): string {
        return `${this.user.firstName[0].toUpperCase()}${this.user.lastName[0].toUpperCase()}`;
    }

    private createImageFromBlob(image?: Blob): void {
        const reader = new FileReader();
        reader.onload = () => {
            this.userPhoto = reader.result;
        };

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    get isProfileAvaliable(): boolean {
        return this.user.employeeGroupDesc === SharedModels.CE.EEmployeeGroupDesc.External
            || this.user.employeeGroupDesc === SharedModels.CE.EEmployeeGroupDesc.Active;
    }
}
